/**
 * Global constants for the CFES Admin Tool
 */

/**
 * External URLs
 */
export const EXTERNAL_URLS = {
    CFES_ACCESS_GUIDE: 'https://devstack.vwgroup.com/confluence/pages/viewpage.action?spaceKey=FOD&title=4.1+-+How+to+apply+for+CFES+kira+role'
}

/**
 * SSO pending timeout in milliseconds (5 minutes)
 */
export const SSO_PENDING_TIMEOUT = 5 * 60 * 1000

/**
 * Login cache validity timeout in milliseconds (10 minutes)
 */
export const LOGIN_CACHE_TIMEOUT = 10 * 60 * 1000

/**
 * Interval for proactive session refresh in milliseconds
 * Must be shorter than {@link LOGIN_CACHE_TIMEOUT}
 */
export const SESSION_REFRESH_INTERVAL = 5 * 60 * 1000

/**
 * Longest allowed user idle time in milliseconds (30 minutes). After this period of inactivity, user session will no longer be maintained.
 * Must be larger than {@link LOGIN_CACHE_TIMEOUT} 
*/
export const MAX_USER_IDEL_TIME = 30 * 60 * 1000

/**
 * Global region identifier for routes without region restriction
 */
export const GLOBAL_REGION = 'GLOBAL'

/**
 * Global brand identifier for routes without brand restriction
 */
export const GLOBAL_BRAND = 'ALL'

/**
 * Permission string representing all permissions
*/
export const ALL_PERMISSION = '*:*:*'

/**
 * Storage key for SSO pending state
 */
export const SSO_PENDING_KEY = 'CFES_SSO_PENDING'

/**
 * Storage key for authentication state
 */
export const AUTH_STATE_KEY = 'CFES_AUTH_STATE'

/**
 * Storage key for router map
 */
export const ROUTER_MAP_KEY = 'CFES_ROUTER_MAP'
